import { useState, useEffect, Fragment, useRef } from "react";
import Overview from "./Overview";
import {
  getDoorStates,
  getBoxStates,
  getCompartmentStates,
  moveDoor,
  moveBox,
  moveCompartment,
} from "../../../fetchApi";
import { setDoInterval } from "../../../utils";

function OperableElement({ name, state, onAction, children }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        border: "2px solid #e0e0e0",
        borderRadius: 5,
        padding: 5,
        margin: 5,
        minWidth: 320,
      }}
    >
      <div style={{ display: "flex", flexDirection: "row", fontSize: "120%", fontWeight: "bold" }}>
        <div>{name}</div>
        <button
          style={{ marginLeft: 10 }}
          className="btn btn-success btn-sm"
          onClick={() => onAction("open")}
        >
          Open
        </button>
        <button
          style={{ marginLeft: 5 }}
          className="btn btn-danger btn-sm"
          onClick={() => onAction("close")}
        >
          Close
        </button>
        <div style={{ color: "#505050", marginLeft: 10 }}>{state}</div>
      </div>
      <div style={{ marginLeft: 20 }}>{children}</div>
    </div>
  );
}

export default function Maintenance({ vehicle, onScrollReady }) {
  const [doors, setDoors] = useState([]);
  const [boxes, setBoxes] = useState({});
  const [compartments, setCompartments] = useState({});
  const [hasAllData, setHasAllData] = useState(false);
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (hasAllData && !hasScrolled.current) {
      onScrollReady();
      hasScrolled.current = true;
    }
  }, [hasAllData, onScrollReady]);

  useEffect(() => {
    async function update() {
      const doorsRes = await getDoorStates(vehicle.id);
      setDoors(doorsRes);

      const boxesRes = await getBoxStates(vehicle.id);
      for (const door of doorsRes) {
        setBoxes((prev) => ({
          ...prev,
          [door.id]: boxesRes.filter((box) => box.doorId === door.id),
        }));
      }

      const toWait = [];
      for (const box of boxesRes) {
        if (box.id !== null) {
          toWait.push(
            getCompartmentStates(vehicle.id, box.idx).then((compartmentsRes) => {
              setCompartments((prev) => ({
                ...prev,
                [box.idx]: compartmentsRes,
              }));
            })
          );
        }
      }
      await Promise.all(toWait);

      setHasAllData(true);
    }

    const updateInterval = setDoInterval(
      () => update().catch((err) => console.error("maintenance err:", err)),
      2000
    );

    return () => {
      clearInterval(updateInterval);
    };
  }, [vehicle.id]);

  return (
    <>
      <div className="col-12">
        <Overview vehicleId={vehicle.id} />
      </div>
      <div
        className="col-12"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          marginBottom: 15,
        }}
      >
        {doors.map((door) => (
          <Fragment key={door.id}>
            <OperableElement
              name={"Door " + door.id}
              state={door.state}
              onAction={(action) => moveDoor(vehicle.id, door.id, action)}
            >
              {boxes[door.id]?.map((box) => (
                <Fragment key={box.idx}>
                  <OperableElement
                    name={"Box " + box.idx}
                    state={box.state}
                    onAction={(action) => moveBox(vehicle.id, box.idx, action)}
                  >
                    {compartments[box.idx]?.map((compartment) => (
                      <Fragment key={compartment.idx}>
                        <OperableElement
                          name={"C" + compartment.idx}
                          state={compartment.state}
                          onAction={(action) =>
                            moveCompartment(vehicle.id, box.idx, compartment.idx, action)
                          }
                        />
                      </Fragment>
                    ))}
                  </OperableElement>
                </Fragment>
              ))}
            </OperableElement>
          </Fragment>
        ))}
      </div>
    </>
  );
}
